import { CDN_IMAGES, CART_BASE_URL, BRAND_BASE_URL } from 'src/constants/param-constants';

import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common'
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm, FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage-angular';
import { ActivatedRoute, Router } from '@angular/router';


import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { OrderProviderExtender } from '../../providers/order/order-extender';
import { TouchcrApiOrderformProvider } from '../../providers/touchcr-api-orderform/touchcr-api-orderform';
import { CartProvider } from '../../providers/cart/cart';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiLeadProvider } from '../../providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiCouponProvider } from '../../providers/touchcr-api-coupon/touchcr-api-coupon';
import { OrderDetailsProvider } from '../../providers/order-details/order-details';
import { TouchcrApiShippingProvider } from '../../providers/TouchcrApiShippingProvider';
import { CalculateProvider } from '../../providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { OrderProvider } from 'src/app/providers/order/order';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { SpinnerProvider } from '../../providers/spinner/spinner';
import { TouchcrApiGeneralExtenderProvider } from '../../providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiOrderExtenderProvider } from '../../providers/touchcr-api-order/touchcr-api-order-extender';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { PaypalPaymentExtenderProvider } from '../../providers/paypal/paypal-extender';
import { StateProvider } from 'src/app/providers/state';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { Country } from '../../models/country';
import { CHECKOUT_LABEL, PAYMENT_LABEL, SHIPPING_LABEL } from 'src/constants/constants';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CheckoutCommon } from '../_brand-pages-base/base-controllers/checkout/checkout-common';

@Component({
    selector: 'checkout-common-tc',
    templateUrl: './checkout-commonTC.html',
    styleUrls: ['./checkout-commonTC.scss'],
    standalone: false
})
export class CheckoutCommonTC extends CheckoutCommon {
  public override isSelectedCB2: boolean = true;
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: Location,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    public override route: ActivatedRoute,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      route,
      storage
    );
  }

  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa', 'checkout-page');

    this.headerText = '';
    this.showOnOrderForm = true;

    this.setDynamicCustomerServiceInfo();

    const currentParams = { ...this.route.snapshot.queryParams };

    if (!currentParams["step"]) {
          currentParams["step"] = 1;
          const baseUrl = this.location.path(false).split('?')[0];
          const queryString = new URLSearchParams(currentParams).toString();
    
          this.location.replaceState(`${baseUrl}?${queryString}`);
    }

    if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Germany') {
      this.headerText = `<h2>KUNDENDIENST</h2><p>+1 (800) 852-0477 | MF 7:00–17:00 UHR PST | SS 7:00–16:00 UHR PST</p>`;
    } else if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Mexico') {
      this.headerText = `<h2>Servicio al cliente</h2><p>(800) 611-9075 |M-F 7AM-5PM PST | S-S 7AM-4PM PST</p><p>servicioalcliente@drmartypets.com</p>`;
    } else {
      if (this.braintreeDefaultCountry && this.braintreeDefaultCountry != 'United States') {
        this.headerText = '<br><h2>CUSTOMER SERVICE</h2>' +
          `<p>${this.dynamicPhoneNumber}<br>${this.dynamicCustomerServiceHours}</p>`;
      } else {
        this.headerText = '<h2>Agents standing by to help</h2>' +
          `<p>${this.dynamicPhoneNumber}</p>`;
      }
    }
    this.showOnOrderForm = true;
    if (this.showCoupon) {
      setTimeout(() => {
        this.getCoupon();
      }, 500)
    }
  }

  override async payPalAddressHandler(payload: any) {
    console.log('[GH] payPalAddressHandler v2 - issue with email validation that did not happen in the original checkout-common');
    await super.payPalAddressHandler(payload);
    try {
      if (this.accountForm?.form?.controls?.email) {
        this.accountForm.form.controls.email.updateValueAndValidity(); // DEV-46966
      }
    } catch (error) {
      console.error('[GH] Error updating email validity:', error);
    }
  }
} 